module.exports = __webpack_public_path__ + "static/Icons_FirstTimeHB_Large-6339c87759b954a2bdecb3029e9fd7b3.png";